import { render, staticRenderFns } from "./layout-alert-info.vue?vue&type=template&id=d79cc51c&scoped=true&"
import script from "./layout-alert-info.vue?vue&type=script&lang=js&"
export * from "./layout-alert-info.vue?vue&type=script&lang=js&"
import style0 from "./layout-alert-info.vue?vue&type=style&index=0&id=d79cc51c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79cc51c",
  null
  
)

export default component.exports